import React from "react";
import { useParams, Link } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import SiteShell from "../components/site/SiteShell";
import { Container, Button, Eyebrow } from "../components/site/ui";
import { Reveal } from "../components/site/Reveal";
import { FinalCTA } from "./HomeNew";
import { CONCEPTS } from "../data/site";

export default function OurWorkDetail() {
  const { slug } = useParams();
  const c = CONCEPTS.find((x) => x.slug === slug);

  if (!c) {
    return (
      <SiteShell title="Concept not found — GoBuildWeb">
        <Container className="py-40 text-center">
          <h1 className="font-display text-3xl font-bold text-white">Concept not found</h1>
          <Button to="/what-we-can-build" className="mt-6" data-testid="detail-back">Back to What We Can Build</Button>
        </Container>
      </SiteShell>
    );
  }

  return (
    <SiteShell title={`${c.name} — Concept Website | GoBuildWeb`} description={c.description} testId="concept-detail-page">
      <section className="pt-[92px]">
        <Container className="py-8">
          <Link to="/what-we-can-build" className="inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-gold-400" data-testid="detail-back"><ArrowLeft size={15} /> What We Can Build</Link>
        </Container>
        <Container className="grid items-start gap-10 pb-16 lg:grid-cols-[1.1fr_0.9fr] md:pb-24">
          <Reveal>
            <div className="overflow-hidden rounded-3xl border border-white/10">
              <img src={c.img} alt={c.name} className="h-[300px] w-full object-cover md:h-[460px]" />
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <span className="inline-block rounded-full bg-gold-500/10 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-gold-400 ring-1 ring-gold-500/40">{c.tag}</span>
            <Eyebrow>{c.industry}</Eyebrow>
            <h1 className="mt-3 font-display text-4xl font-bold tracking-tight text-white md:text-5xl">{c.name}</h1>
            <p className="mt-4 text-zinc-400">{c.description}</p>
            <h3 className="mt-8 text-xs font-bold uppercase tracking-[0.2em] text-zinc-500">Key features</h3>
            <ul className="mt-4 grid grid-cols-1 gap-2.5 sm:grid-cols-2">
              {c.features.map((f) => (
                <li key={f} className="flex items-center gap-2.5 text-sm text-zinc-200"><Check size={15} className="text-gold-500" /> {f}</li>
              ))}
            </ul>
            <div className="mt-9 flex flex-wrap gap-3">
              <Button to="/get-started" size="lg" data-testid="detail-get-website">Get My Website</Button>
            </div>
            <p className="mt-4 text-xs text-zinc-600">This is a concept design created by GoBuildWeb to demonstrate quality, not a client project.</p>
          </Reveal>
        </Container>
      </section>
      <FinalCTA />
    </SiteShell>
  );
}
